import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  RequestHook_instance2bttwktu7kqh4 as RequestHook_instance,
  TransformRequestBodyHook_instance28bvckwiy2plb as TransformRequestBodyHook_instance,
  TransformResponseBodyHook_instance1622bcqff9eap as TransformResponseBodyHook_instance,
} from './KtorCallContexts.mjs';
import { HookHandler356pvj77mag23 as HookHandler } from './ClientHook.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ClientPluginBuilder$onClose$lambda() {
  return Unit_instance;
}
var ClientPluginBuilderClass;
function ClientPluginBuilder() {
  if (ClientPluginBuilderClass === VOID) {
    class $ {
      constructor(key, client, pluginConfig) {
        this.x5m_1 = key;
        this.y5m_1 = client;
        this.z5m_1 = pluginConfig;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.a5n_1 = ArrayList().u2();
        var tmp_0 = this;
        tmp_0.b5n_1 = ClientPluginBuilder$onClose$lambda;
      }
      e5s(block) {
        this.c5n(RequestHook_instance, block);
      }
      p5u(block) {
        this.c5n(TransformRequestBodyHook_instance, block);
      }
      h5q(block) {
        this.c5n(TransformResponseBodyHook_instance, block);
      }
      c5n(hook, handler) {
        this.a5n_1.n2(new (HookHandler())(hook, handler));
      }
    }
    initMetadataForClass($, 'ClientPluginBuilder');
    ClientPluginBuilderClass = $;
  }
  return ClientPluginBuilderClass;
}
//region block: exports
export {
  ClientPluginBuilder as ClientPluginBuilder3nx9qxmpfnzts,
};
//endregion

//# sourceMappingURL=ClientPluginBuilder.mjs.map
